export default "__VITE_ASSET__CY8Gcyv___"